import subscriptionService from "../services/subscription.service";

const unwrap = (response) =>
  response?.data?.data ?? response?.data?.body ?? response?.data;

export const getAllSubscriptions = async (params) => {
  const res = await subscriptionService.getAllSubscriptions(params);
  return unwrap(res) || { docs: [], pagination: {} };
};

export const getBillingStatus = async (accountUrn) => {
  const res = await subscriptionService.getBillingStatus(accountUrn);
  return unwrap(res);
};

export const getSubscriptionInvoices = async (subscriptionId) => {
  const res = await subscriptionService.getInvoices(subscriptionId);
  return unwrap(res) || [];
};

export const activateSubscription = async (subscriptionId) => {
  const res = await subscriptionService.activateSubscription(subscriptionId);
  return unwrap(res);
};

export const cancelSubscription = async (subscriptionId) => {
  const res = await subscriptionService.cancelSubscription(subscriptionId);
  return unwrap(res);
};

export const resumeSubscription = async (subscriptionId) => {
  const res = await subscriptionService.resumeSubscription(subscriptionId);
  return unwrap(res);
};

export const retrySubscriptionPayment = async (subscriptionId) => {
  const res = await subscriptionService.retrySubscriptionPayment(subscriptionId);
  return unwrap(res);
};
